import { VdsCheckbox, VdsField } from '@volt/volt-extended-components-react';
import { ReactElement, useCallback } from 'react';
import { FieldValues, useController, UseControllerProps } from 'react-hook-form';
import styles from './CasFormCheckbox.module.scss';

interface CasFormCheckboxProps<TFormValues extends FieldValues>
  extends UseControllerProps<TFormValues> {
  label: string;
  isReadonly?: boolean;
}

export const CasFormCheckbox = <TFormValues extends FieldValues>(
  props: CasFormCheckboxProps<TFormValues>,
): ReactElement => {
  const { disabled, ...sanitisedProps } = props;
  const { field, fieldState, formState } = useController(sanitisedProps);

  const { name, label } = props;

  const onCheckboxChange = useCallback(() => {
    field.onChange(!field.value);
  }, [field]);

  const errorMessage =
    !(props.disabled || field.disabled) && fieldState.error ? fieldState.error.message : '';

  return (
    <VdsField
      key={name}
      label={''}
      errorMessage={errorMessage}
      isDisabled={props.disabled || field.disabled || formState.isSubmitting}
    >
      {/* VDS Note: Unaltered, the VdsField cause the checkbox to be center-aligned without filling the width of the field. */}
      <div className={styles.vdsWorkaround}>
        <VdsCheckbox
          labelValue={label}
          size="medium"
          checked={field.value}
          onCheckboxChange={onCheckboxChange}
          // There is no readonly state for the VdsCheckbox, so disable it instead.
          disabled={disabled || props.isReadonly}
          error={fieldState.error !== undefined}
          onBlur={field.onBlur}
        />
      </div>
    </VdsField>
  );
};

export default CasFormCheckbox;
